import React from "react";
import styled from "styled-components/macro";
import { COLORS } from "helpers/designConstants";

// The only mailto: link in the participant UI. index.css defines no `a` rule,
// so without these styles a bare anchor renders browser-default blue /
// underlined / purple-visited, off-brand against the black uppercase treatment.
//
// Renders nothing for an empty address so callers can pass a possibly-missing
// value without guarding at every call site.
const ContactEmailLink = ({ email, className }) => {
  const address = typeof email === "string" ? email.trim() : "";
  if (address.length === 0) return null;

  return (
    <EmailLink
      className={className}
      // encodeURI handles spaces but deliberately leaves URL-significant
      // characters alone. In a mailto: URI both "#" and "?" are significant —
      // "#" starts a fragment and "?" starts the header list — so either one
      // silently truncates the address the mail client actually composes to.
      // No UI path can produce them (both email fields are pattern-validated),
      // but a legacy or SDK-written value could.
      href={`mailto:${encodeURI(address).replace(/[#?]/g, encodeURIComponent)}`}
    >
      {address}
    </EmailLink>
  );
};

const EmailLink = styled.a`
  color: ${COLORS.text};
  text-decoration: underline;
  /* inline-block so the vertical padding actually enlarges the touch target */
  display: inline-block;
  padding: 4px 2px;
  /* An email is one unbreakable token (~340px at 18px) and html/body set
     overflow: hidden in index.css, so an overflowing address is clipped, not
     scrollable — part of the tap target would be unreachable on a phone. */
  overflow-wrap: anywhere;

  &:visited {
    color: inherit;
  }
`;

export default ContactEmailLink;
